import { useEffect, useMemo, useState } from 'react'

function getNextUtcMidnight(nowMs: number): Date {
  const now = new Date(nowMs)
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 0, 0, 0, 0))
}

function formatRemaining(msRemaining: number): string {
  const totalSeconds = Math.max(0, Math.floor(msRemaining / 1000))
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  if (hours > 0) return `${hours}h ${minutes}m`
  if (minutes > 0) return `${minutes}m`
  return `${seconds}s`
}

export function useUtcMidnightCountdown(options?: { tickMs?: number }) {
  const tickMs = options?.tickMs ?? 30_000
  const [nowMs, setNowMs] = useState(() => Date.now())

  useEffect(() => {
    const intervalId = setInterval(() => setNowMs(Date.now()), tickMs)
    return () => clearInterval(intervalId)
  }, [tickMs])

  return useMemo(() => {
    const nextResetAt = getNextUtcMidnight(nowMs)
    const msRemaining = nextResetAt.getTime() - nowMs

    return {
      nextResetAt,
      msRemaining: Math.max(0, msRemaining),
      formattedRemaining: formatRemaining(msRemaining),
    }
  }, [nowMs])
}

